var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsset4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 57.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.52,1.08A15,15,0,0,0,28,7,15,15,0,1,0,4.87,26.08a20.74,20.74,0,0,1,5.59,13.85V50.35a6.23,6.23,0,0,0,6.23,6.23h0a6.23,6.23,0,0,0,6.23-6.23V37.55A5.08,5.08,0,0,1,28,32.47h0a5.07,5.07,0,0,1,5.08,5.08v12.8a6.24,6.24,0,0,0,6.24,6.23h0a6.23,6.23,0,0,0,6.23-6.23V39.93a20.69,20.69,0,0,1,5.59-13.85,15,15,0,0,0-9.62-25Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 17.64,
    y: 12.92,
    width: 20.73,
    height: 9.56,
    rx: 2.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 38.37,
    y1: 17.7,
    x2: 54.91,
    y2: 17.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 17.64,
    y1: 17.7,
    x2: 1.09,
    y2: 17.7
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset4);
export default __webpack_public_path__ + "static/media/Asset 4.16c2677ccd4074eae5da2e0698383695.svg";
export { ForwardRef as ReactComponent };